import { hotelAttributes } from "../utils";
import { MdCheck } from "react-icons/md";
export default function HotelAttributes(props) {
  const { hotel } = props;

  return (
    <>
      <div
        style={{
          display: "flex",
          flexFlow: "row wrap",
          justifyContent: "space-between",
          paddingTop: 30,
        }}
      >
        {hotel &&
          Array.isArray(hotel.HotelAttributes) &&
          hotel.HotelAttributes.map((e, i) => (
            <>
              {hotelAttributes.find((a) => i < 100 && e === a.value) && (
                <div style={{ flex: "25%", paddingBottom: 16 }} key={e}>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: 30 }}>
                      {hotelAttributes.find((a) => e === a.value) ? (
                        hotelAttributes.find((a) => e === a.value).icon ? (
                          hotelAttributes.find((a) => e === a.value).icon()
                        ) : (
                          <MdCheck style={{ verticalAlign: "bottom" }} />
                        )
                      ) : (
                        <MdCheck style={{ verticalAlign: "bottom" }} />
                      )}
                    </div>
                    <div style={{}}>
                      {hotelAttributes.find((a) => e === a.value)
                        ? hotelAttributes.find((a) => e === a.value).label
                        : e}
                    </div>
                  </div>
                </div>
              )}
            </>
          ))}
      </div>

      {/*hotel &&
        Array.isArray(hotel.HotelAttributes) &&
        hotel.HotelAttributes.map((e) => (
          <div className="hotelattributes" key={e}>
            {hotelAttributes.find((a) => e === a.value)
              ? hotelAttributes.find((a) => e === a.value).label
              : e}
            <br />
          </div>
            ))*/}
    </>
  );
}
